/* eslint-disable max-len, no-shadow, no-param-reassign, no-prototype-builtins */
import { writeTokenToCookie, deleteTokenCookie } from '@helper/agentTokenCookie'
import mutationTypes from '../../mutation-types'
import { resetState } from '../../state-helper'
import authenticationService from '../../services'

function initialState() {
  return {
    details: {
      id: null,
      internalId: null,
      company: null,
      gender: null,
      title: null,
      firstName: null,
      lastName: null,
      status: null,
      emails: null,
      dispatchOptions: {
        emails: null,
        customerDocuments: null,
        invoices: null,
        reminders: null,
      },
    },
    token: null,
    isAgent: false,
    whitelabel: {
      flexDrive: true,
      key: null,
    },
  }
}

export const state = initialState()

export const INITIALIZE_AGENT = 'INITIALIZE_AGENT'

export const actions = {
  async [INITIALIZE_AGENT] (context, payload) {
    const { token } = payload
    try {
      const agent = await authenticationService.getAuthAgentDetails(payload)
      if (agent) {
        context.commit('SET_AGENTDETAILS', agent)
        context.commit('AUTHENTICATE_AGENT', token)
        return true
      }
    } catch (error) {
      context.commit('RESET_AGENT')
      context.commit('resetNewContractState')
      return false
    }
    return false
  },
}

export const mutations = {
  [mutationTypes.RESET_AGENT] (state) {
    resetState(state, initialState())
    deleteTokenCookie()
  },
  [mutationTypes.SET_AGENTDETAILS] (state, payload) {
    Object.keys(state.details).forEach((key) => {
      if (Object.keys(payload).includes(key)) {
        state.details[key] = payload[key]
      }
    })
  },
  [mutationTypes.SET_WHITELABEL_DETAILS] (state, payload) {
    Object.keys(state.whitelabel).forEach((key) => {
      if (Object.keys(payload).includes(key)) {
        state.whitelabel[key] = payload[key]
      }
    })
  },
  [mutationTypes.AUTHENTICATE_AGENT] (state, payload) {
    state.token = payload
    state.isAgent = true
    writeTokenToCookie(payload)
  },
}

export default {
  state,
  mutations,
  actions,
}
